/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

interface Animate {
  animate: boolean;
}

export const Root = styled(Box, {
  shouldForwardProp: prop => prop !== 'animate',
})<Animate>(({animate}) => ({
  width: animate ? 26 : 13,
  height: animate ? 8 : 15,
  position: 'relative',
  transition: '0.2s',
}));

export const Circle = styled(Box)(({theme}) => ({
  background: theme.palette.figma_primary?.main,
  borderRadius: '100%',
  position: 'absolute',
  transition: '0.2s',
}));

export const Circle1 = styled(Circle, {
  shouldForwardProp: prop => prop !== 'animate',
})<Animate>(({animate}) => ({
  width: 4,
  height: 4,
  right: animate ? 22 : 0,
  bottom: 2,
}));

export const Circle2 = styled(Circle, {
  shouldForwardProp: prop => prop !== 'animate',
})<Animate>(({animate}) => ({
  width: 6,
  height: 6,
  left: animate ? 20 : 0,
  bottom: animate ? 1 : 0,
}));

export const Circle3 = styled(Circle, {
  shouldForwardProp: prop => prop !== 'animate',
})<Animate>(({animate}) => ({
  width: 8,
  height: 8,
  top: 0,
  right: animate ? 10 : 2,
}));
